import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrHT: CultureInfo = {
  name: 'fr-HT',
  displayName: 'French (Haiti)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-HT',
  parent: CultureInfoFr
};
